import './IdentificationMethod.scss';

/* eslint-disable react/jsx-handler-names */
import calendarIcon from 'assets/icons/calendar.svg';
import calendarIconSelected from 'assets/icons/calendarBlue.svg';
import penguinBankTransferIdentification from 'assets/icons/penguin-bank-transfer-identification-iban.svg';
import penguinIban from 'assets/icons/penguin-iban.svg';
import penguinVideoCall from 'assets/icons/penguin-video-call.svg';
import penguinVideoSelfie from 'assets/icons/penguin-video-selfie.svg';
import BasicModalMobileFull from 'components/commons/basicModalMobileFull/basicModalMobileFull';
import IdentificationMethodContext from 'components/newAccountSteps/profileSteps/profileStep3/IdentificationMethod/IdentificationMethodContext/IdentificationMethodContext';
import VerificationMethodContent from 'components/newIdentifyMethods/VerificationMethodContent/VerificationMethodContent';
import {
    ROBO_IBAN,
    ROBO_TRANSFER,
    ROBO_VIDEOCALL,
    ROBO_VIDEOS,
    ROBO_VIDEOSELFIE,
    TC_IBAN,
    TC_VIDEOCALL,
    TC_VIDEOS,
    TC_VIDEOSELFIE,
    VIDEOCALLS_IN_1_BOX,
} from 'constants/featureFlagging';
import { COURIER, IBAN, TRANSFER_CERTIFICATE, VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';
import { formatText } from 'core/i18n';
import React from 'react';
import { useIdentityView } from 'routes/formsView/IdentityVerificationViews/IdentityView/contexts/IdentityViewContext/IdentityViewContext';
import { recordEventCustomOnly } from 'utilities/uTagging';
import BoxOptions from '../BoxOptions/BoxOptions';
import BoxOptionsContainer from '../BoxOptions/BoxOptionsContainers/BoxOptionsContainer';
import ModalOptions from '../ModalOptions/ModalOptions';
import { getMethodTextsProps } from 'components/newAccountSteps/profileSteps/profileStep3/IdentificationMethod/utilities/getMethodTextsProps';

const IdentificationMethod = ({
    identOrderByCountry,
    selectedIdent,
    selectedIdentIndex,
    videoAvailability,
    tagByCountry,
    showIbanFailPopUP,
    handleShowIbanErrorModal,
    handleCloseIbanErrorModal,
    bankName,
    documentRequiredText,
    handleIsTimeAvailableForVideoContent,
    onChangeTab,
    storage,
    isIbanActive,
    onClickOption = () => {},
}) => {
    const { isCarrouselActive, isSelectedVideoselfieWithBiometrics } = useIdentityView();

    const handleClickSelected = selected => {
        const selectedIdent = identOrderByCountry[selected];
        onClickOption(selectedIdent);
    };

    const buildMethodOptionsEnumWithType = (selectedIdent, disabled) => ({
        [COURIER]: {
            ...getMethodTextsProps(COURIER),
            img: selectedIdent === COURIER ? calendarIconSelected : calendarIcon,
            onClick: handleClickSelected,
        },
        [IBAN]: {
            ...getMethodTextsProps(IBAN),
            img: penguinIban,
            onClick: handleClickSelected,
        },
        [ROBO_IBAN]: {
            ...getMethodTextsProps(ROBO_IBAN),
            img: penguinIban,
            onClick: handleClickSelected,
        },

        [ROBO_TRANSFER]: {
            ...getMethodTextsProps(ROBO_TRANSFER),
            img: penguinBankTransferIdentification,
            onClick: handleClickSelected,
        },
        [ROBO_VIDEOCALL]: {
            ...getMethodTextsProps(ROBO_VIDEOCALL),
            img: penguinVideoCall,
            onClick: disabled ? () => {} : handleClickSelected,
        },
        [ROBO_VIDEOS]: {
            ...getMethodTextsProps(ROBO_VIDEOS),
            img: penguinVideoCall,
            onClick: disabled ? () => {} : handleClickSelected,
        },

        [ROBO_VIDEOSELFIE]: {
            ...getMethodTextsProps(ROBO_VIDEOSELFIE),
            img: penguinVideoSelfie,
            onClick: disabled ? () => {} : handleClickSelected,
        },
        [TC_IBAN]: {
            ...getMethodTextsProps(TC_IBAN),
            img: penguinIban,
            onClick: handleClickSelected,
        },
        [TC_VIDEOCALL]: {
            ...getMethodTextsProps(TC_VIDEOCALL),
            img: penguinVideoCall,
            onClick: disabled ? () => {} : handleClickSelected,
        },

        [TC_VIDEOS]: {
            ...getMethodTextsProps(TC_VIDEOS),
            img: penguinVideoCall,
            onClick: disabled ? () => {} : handleClickSelected,
        },
        [TC_VIDEOSELFIE]: {
            ...getMethodTextsProps(TC_VIDEOSELFIE),
            img: penguinVideoSelfie,
            onClick: disabled ? () => {} : handleClickSelected,
        },
        [TRANSFER_CERTIFICATE]: {
            ...getMethodTextsProps(TRANSFER_CERTIFICATE),
            img: penguinBankTransferIdentification,
            onClick: handleClickSelected,
        },

        [VIDEOCALLS_IN_1_BOX]: {
            ...getMethodTextsProps(VIDEOCALLS_IN_1_BOX),
            img: penguinVideoCall,
            onClick: disabled ? () => {} : handleClickSelected,
        },
        [VIDEO_CALL]: {
            ...getMethodTextsProps(VIDEO_CALL),
            img: penguinVideoCall,
            onClick: disabled ? () => {} : handleClickSelected,
        },

        [VIDEO_SELFIE]: {
            ...getMethodTextsProps(VIDEO_SELFIE, isSelectedVideoselfieWithBiometrics),
            img: penguinVideoSelfie,
            onClick: disabled ? () => {} : handleClickSelected,
        },
    });

    const handleCloseWithTag = () => {
        handleCloseIbanErrorModal(true);
    };

    const buildHeaderIdentificationMethod = (
        type,
        selectedIdent,
        tag = undefined,
        disabled = false,
        isTimeAvailable,
        isPopUp = false,
        popUpSelection
    ) => {
        const { onClick, title, abbrTitle, content, img, modalButtonText, timeAlertText, modalTittle, modalContent } =
            buildMethodOptionsEnumWithType(selectedIdent, disabled)[type];
        const handleClickSelection = index => {
            onChangeTab();
            if (isPopUp) {
                if (!disabled && isTimeAvailable) {
                    recordEventCustomOnly({
                        categoriaEvento: 'onboarding',
                        accionEvento: 'identidad/iban/modal-iban/no-disponible',
                        etiquetaEvento: formatText(modalButtonText),
                    });
                    handleCloseIbanErrorModal();
                    onClick(popUpSelection);
                    window.scrollTo(0, 0);
                }
            } else {
                onClick(index);
            }
        };

        const onShowDisableTimeAlert = () => {
            recordEventCustomOnly({
                categoriaEvento: 'onboarding',
                accionEvento: 'identidad/iban/modal-iban/no-disponible',
                etiquetaEvento: 'videollamada horario no disponible',
            });
        };

        return isPopUp ? (
            <ModalOptions
                key={type}
                onClick={handleClickSelection}
                title={formatText(modalTittle)}
                content={formatText(modalContent, [documentRequiredText])}
                buttonText={formatText(modalButtonText)}
                timeAlertText={!isTimeAvailable && timeAlertText && formatText(timeAlertText)}
                onShowDisableTimeAlert={onShowDisableTimeAlert}
                img={img}
                disabled={disabled}
            />
        ) : (
            <BoxOptionsContainer
                key={type}
                onClick={handleClickSelection}
                tag={tag}
                title={formatText(title)}
                abbrTitle={formatText(abbrTitle)}
                content={formatText(content)}
                img={img}
                selected={selectedIdent}
                disabled
            />
        );
    };

    const isVideoCallOrVideoSelfieDisabled = (type, videoAvailability) => {
        if (type === VIDEO_CALL) return !videoAvailability.get(VIDEO_CALL);
        if (type === VIDEO_SELFIE) return !videoAvailability.get(VIDEO_SELFIE);

        return false;
    };

    return (
        <div>
            <IdentificationMethodContext.Provider value={{ onClickOption }}>
                {isCarrouselActive && (
                    <BoxOptions selectedBox={[selectedIdentIndex]}>
                        {identOrderByCountry.map(type =>
                            buildHeaderIdentificationMethod(
                                type,
                                selectedIdent,
                                tagByCountry.includes(type),
                                isVideoCallOrVideoSelfieDisabled(type, videoAvailability)
                            )
                        )}
                    </BoxOptions>
                )}

                <BasicModalMobileFull
                    info={formatText('identity-ibanModalTitle', [bankName])}
                    showModal={showIbanFailPopUP}
                    closeModal={handleCloseWithTag}
                >
                    <div className="container-option-modal">
                        {identOrderByCountry.map((type, index) =>
                            buildHeaderIdentificationMethod(
                                type,
                                selectedIdent,
                                tagByCountry.includes(type),
                                isVideoCallOrVideoSelfieDisabled(type, videoAvailability),
                                handleIsTimeAvailableForVideoContent(type),
                                true,
                                index
                            )
                        )}
                    </div>
                </BasicModalMobileFull>

                <VerificationMethodContent
                    selectedIdentification={selectedIdent}
                    handleShowIbanErrorModal={handleShowIbanErrorModal}
                    storage={storage}
                    isIbanActive={isIbanActive}
                />
            </IdentificationMethodContext.Provider>
        </div>
    );
};

export default IdentificationMethod;
